<template>
  <el-dialog
    title="修改工作组"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :modal="false"
    width="600px"
  >
    <div>
      <div class="header">
        <span class="mr10">团队名称：{{ team.teamName }}</span>
        <el-button type="primary" size="mini" @click="toUpdateTeam">编辑</el-button>
      </div>

      <div>
        <div><span>团队成员：</span></div>
        <el-table :data="team.members" border height="300" style="width: 420px">
          <el-table-column prop="date" label="用户名" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="姓名" width="160">
            <template slot-scope="scope">
              <span>{{ getUserName(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" @click="setTeamMemberDetail(scope.row)">管理</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="team.children">
        <div>
          <span>子团队（{{ (team.children && team.children.length) || 0 }}）：</span>
          <el-button type="primary" size="mini" @click="toAddTeam">新建下级部门</el-button>
        </div>
        <div class="child-team-box">
          <div v-for="child in team.children" :key="child._id" class="child-team">
            <span class="mr10"
              >组织名称：
              <el-button type="text" @click="open(child)">{{ child.teamName }}</el-button>
            </span>
            <span class="mr10">组织类型：{{ child.teamType }}</span>
            <span class="mr10">负责人：{{ child.leader }}</span>
          </div>
        </div>
      </div>
    </div>
    <AddTeam ref="AddTeam" @addTeam="open(team)"></AddTeam>
    <UpdateTeam ref="UpdateTeam" @updateTeam="open(team)"></UpdateTeam>
    <MemberDetail ref="MemberDetail"></MemberDetail>
    <span slot="footer" class="dialog-footer">
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="dialogVisible = false">取 消</div>
      <div class="radish-btn radish-btn-primary radish-btn-small" @click="confirm">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
import AddTeam from './team/AddTeam'
import UpdateTeam from './team/UpdateTeam'
import MemberDetail from './team/MemberDetail'

export default {
  components: { AddTeam, UpdateTeam, MemberDetail },
  data() {
    return {
      dialogVisible: false,
      team: { teamName: '', members: [] },
      accounts: [],
      accountMap: {},
    }
  },
  watch: {
    team: {
      handler(newValue, oldValue) {
        if (newValue.parentId && newValue.leader) {
          if (!newValue.members) this.$set(newValue, 'members', [])
          if (!newValue.members.includes(newValue.leader)) newValue.members.push(newValue.leader)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.listUsers()
  },
  methods: {
    // async listUsers() {
    //   const res = await app.service('misc').listUsers()
    //   if (res.status === 'success') {
    //     const usersData = res.data
    //     const accountMap = {}
    //     usersData.forEach(v=>{
    //       accountMap[v.account] = v.姓名
    //     })
    //     this.accountMap = accountMap
    //   }
    // },
    toAddTeam() {
      this.$refs.AddTeam.open(this.team)
    },
    toUpdateTeam() {
      this.$refs.UpdateTeam.open(this.team)
    },
    setTeamMemberDetail(row) {
      this.$refs.MemberDetail.open(this.team, row)
    },
    async open(team) {
      this.accounts = (window.app.accounts || []).filter(v => v)
      const res = await app.service('company').getTeamById({ id: team._id })
      if (res.status === 'success') {
        this.dialogVisible = true
        this.team = res.data
        if (Array.isArray(this.team.children)) {
          this.team.children = this.team.children.filter(v => v.teamType === '业务团队')
        }
      } else this.$message.error(res.msg)
    },
    async getAccounts() {
      const res = await app.service('misc').listAccounts()
      this.accounts = res.data || []
    },
    getUserName(row) {
      const val = (this.accounts || []).find(v => v.account === row)
      return val && val.姓名
    },
    confirm() {
      this.dialogVisible = false
    },
  },
}
</script>
